import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../views/Home';
import OurFinds from '../views/OurFinds';
import Reviews from '../views/Reviews';
import Contact from '../views/Contact';
import LeaveReview from '../views/LeaveReview';
import BeforeAfter from '../views/before-after/BeforeAfter';
import BeforeAfterDeauvilleSeptember2024 from '../views/before-after/DeauvilleSeptember2024';
import BeforeAfterTouquesJanuary2025 from '../views/before-after/TouquesJanuary2025';
import BeforeAfterTourgevilleApril2025 from '../views/before-after/TourgevilleApril2025';
import BeforeAfterDeauvilleOctober2025 from '../views/before-after/DeauvilleOctober2025';
import BeforeAfterTrouvilleJanuary2026 from '../views/before-after/TrouvilleJanuary2026';
import BeforeAfterDeauvilleFebruary2026 from '../views/before-after/DeauvilleFebruary2026';
import BeforeAfterDeauvilleJanuary2026 from '../views/before-after/DeauvilleJanuary2026';
import BeforeAfterDeauvilleMay2026 from '../views/before-after/DeauvilleMay2026';
import BeforeAfterDeauvilleSeptember2026 from '../views/before-after/DeauvilleSeptember2026';
import BeforeAfterBlonvilleSeptember2026 from '../views/before-after/BlonvilleSeptember2026';
import BeforeAfterTrouvilleSeptember2026 from '../views/before-after/TrouvilleSeptember2026';
import BeforeAfterVillersAugust2026 from '../views/before-after/VillersAugust2026';
import LegalNotices from '../views/legal-pages/LegalNotices';
import PrivacyPolicy from '../views/legal-pages/PrivacyPolicy';
import TermOfUse from '../views/legal-pages/TermOfUse';
import TrouvilleSurMer from '../views/city-pages/TrouvilleSurMer';
import Touques from '../views/city-pages/Touques';
import Tourgeville from '../views/city-pages/Tourgeville';
import VillersSurMer from '../views/city-pages/VillersSurMer';
import SaintArnoult from '../views/city-pages/SaintArnoult';
import BenervilleSurMer from '../views/city-pages/BenervilleSurMer';
import BlonvilleSurMer from '../views/city-pages/BlonvilleSurMer';
import Villerville from '../views/city-pages/Villerville';
import Houlgate from '../views/city-pages/Houlgate';
import DivesSurMer from '../views/city-pages/DivesSurMer';
import Auberville from '../views/city-pages/Auberville';
import NotFound from '../views/NotFound';
import ScrollToTop from '../components/ScrollToTop';

const AppRoutes = () => {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/nos-trouvailles" element={<OurFinds />} />
                <Route path="/nos-avis" element={<Reviews />} />
                <Route path="/avant-apres" element={<BeforeAfter />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/laisser-un-avis" element={<LeaveReview />} />
                <Route path="/avant-apres/deauville-septembre-2024" element={<BeforeAfterDeauvilleSeptember2024 />} />
                <Route path="/avant-apres/touques-janvier-2025" element={<BeforeAfterTouquesJanuary2025 />} />
                <Route path="/avant-apres/tourgeville-avril-2025" element={<BeforeAfterTourgevilleApril2025 />} />
                <Route path="/avant-apres/deauville-octobre-2025" element={<BeforeAfterDeauvilleOctober2025 />} />
                <Route path="/avant-apres/trouville-janvier-2026" element={<BeforeAfterTrouvilleJanuary2026 />} />
                <Route path="/avant-apres/deauville-fevrier-2026" element={<BeforeAfterDeauvilleFebruary2026 />} />
                <Route path="/avant-apres/deauville-janvier-2026" element={<BeforeAfterDeauvilleJanuary2026 />} />
                <Route path="/avant-apres/deauville-mai-2026" element={<BeforeAfterDeauvilleMay2026 />} />
                <Route path="/avant-apres/deauville-septembre-2026" element={<BeforeAfterDeauvilleSeptember2026 />} />
                <Route path="/avant-apres/blonville-septembre-2026" element={<BeforeAfterBlonvilleSeptember2026 />} />
                <Route path="/avant-apres/trouville-septembre-2026" element={<BeforeAfterTrouvilleSeptember2026 />} />
                <Route path="/avant-apres/villers-aout-2026" element={<BeforeAfterVillersAugust2026 />} />
                <Route path="/mentions-legales" element={<LegalNotices />} />
                <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
                <Route path="/conditions-utilisation" element={<TermOfUse />} />
                <Route path="/debarras-trouville-sur-mer" element={<TrouvilleSurMer />} />
                <Route path="/debarras-touques" element={<Touques />} />
                <Route path="/debarras-tourgeville" element={<Tourgeville />} />
                <Route path="/debarras-villers-sur-mer" element={<VillersSurMer />} />
                <Route path="/debarras-saint-arnoult" element={<SaintArnoult />} />
                <Route path="/debarras-benerville-sur-mer" element={<BenervilleSurMer />} />
                <Route path="/debarras-blonville-sur-mer" element={<BlonvilleSurMer />} />
                <Route path="/debarras-villerville" element={<Villerville />} />
                <Route path="/debarras-houlgate" element={<Houlgate />} />
                <Route path="/debarras-dives-sur-mer" element={<DivesSurMer />} />
                <Route path="/debarras-auberville" element={<Auberville />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
};

export default AppRoutes;